export default "__VITE_ASSET__BYZkRiwE__"